import { EmptyPage } from "@components/common/empty-page/empty-page";
import { SnapshotsIcon } from "@flat-ui";
import { Box } from "@mui/material";
import { CreateSnapshot } from "@pages/project-details/project-snapshots/create-snapshot";
import { SnapshotsBeingCreatedIndicator } from "@pages/project-details/project-snapshots/snapshots-being-created-indicator";
import {
  selectedProjectIdSelector,
  snapshotsBeingCreatedCountSelector,
} from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { TABS_CONTENT_PADDING } from "@utils/ui-utils";

interface Props {
  /** The debounced search text for filtering the snapshots */
  debouncedSearchText: string;
}

/** Empty page content for snapshots page */
export function SnapshotsEmptyPage({
  debouncedSearchText,
}: Props): JSX.Element {
  const selectedProjectId = useAppSelector(selectedProjectIdSelector);
  const snapshotsBeingCreatedCount = useAppSelector(
    snapshotsBeingCreatedCountSelector
  );

  // No snapshots exist yet, but the first one(s) are still being created
  const isCreatingFirstSnapshot = snapshotsBeingCreatedCount > 0;

  const emptyPageContent = debouncedSearchText.length ? (
    <EmptyPage
      title="No results found"
      subtitle="There are no snapshots that match this search."
      icon={SnapshotsIcon}
    />
  ) : (
    <EmptyPage
      title="You don't have a snapshot yet"
      subtitle={
        isCreatingFirstSnapshot ? (
          <SnapshotsBeingCreatedIndicator />
        ) : (
          "You haven't added snapshots to your project."
        )
      }
      icon={SnapshotsIcon}
      button={
        selectedProjectId && (
          <CreateSnapshot projectId={selectedProjectId} variant="primary" />
        )
      }
    />
  );

  return <Box mt={TABS_CONTENT_PADDING}>{emptyPageContent}</Box>;
}
